import { useQuery } from "react-query";
import { useAppContext } from "../AppProviders";
import { API_URL } from "./helpers";
import { SelfServeReturn } from "./SelfServe";

export function useGetSelfServeReports() {
  const { requestApi } = useAppContext();

  const getSelfServeReports = async (): Promise<SelfServeReturn> => {
    return requestApi
      .get(`${API_URL}/self_service_reports`)
      .then((response) => {
        return response.data;
      });
  };

  const queryResult = useQuery(["selfServeReports"], getSelfServeReports, {
    refetchOnWindowFocus: false,
  });

  return {
    ...queryResult,
    isLoading: queryResult.isLoading,
    data: queryResult.data,
    error: queryResult.error,
  };
}
